import { apiRequest } from '@services/apiClient';
import locationsEndpoints from '@services/locations/locationsEndpoints';

export function listCountriesRequest() {
  return apiRequest(locationsEndpoints.countries);
}

export function listCitiesByCountryRequest(countryId) {
  return apiRequest(locationsEndpoints.citiesByCountry(countryId));
}

export function createCityRequest(payload) {
  return apiRequest(locationsEndpoints.createCity, {
    method: 'POST',
    body: payload
  });
}
